import React from 'react'

import SwiperCore from 'swiper'

import { Swiper, SwiperSlide } from 'swiper/react'

import { BlogCard } from 'src/common/components/BlogCard/BlogCard'
import { ArticleClientType } from 'src/strapi/types/articleTypes'

import s from './ArticleBrowseContent.module.scss'

export type ArticleBrowseContentProps = {
  articles: Array<ArticleClientType>
  onSwiper: (swiper: SwiperCore) => void
}

export const ArticleBrowseContent: React.FC<ArticleBrowseContentProps> = ({
  articles,
  onSwiper,
}) => {
  return (
    <div style={{ width: '100%' }}>
      <Swiper
        slidesPerView="auto"
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 32,
            allowSlideNext: true,
            allowSlidePrev: true,
            allowTouchMove: true,
            loop: true,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 32,
            allowSlideNext: true,
            allowSlidePrev: true,
            allowTouchMove: true,
          },
          1080: {
            slidesPerView: 3,
            spaceBetween: 32,
            mousewheel: false,
            allowSlideNext: false,
            allowSlidePrev: false,
            allowTouchMove: false,
            loop: false,
          },
        }}
        onSwiper={onSwiper}
        updateOnWindowResize
      >
        {articles.map((article, i) => (
          <SwiperSlide key={i}>
            <BlogCard
              key={i}
              className={s.ArticleBrowseContent__card}
              {...article}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
